// extracted by mini-css-extract-plugin
export default {"container":"CreateNoteForm-module__container___nuCWU","visuallyHidden":"CreateNoteForm-module__visuallyHidden___tXJPG","footer":"CreateNoteForm-module__footer___qukwD"};